import React from 'react';
import * as util from "../other/util.js";
import * as Backend from "../backend.js";

// Just displays the GPS object for debugging purposes
class GpsDebugView extends util.GameComponent {
    constructor(props) {
        super(props);
        this.state = { gps: util.getGPS() };
    }

    refreshState() {
        Backend.getPlayerResearchDetails((res) => {
            this.setState({ gps: util.getGPS() });
        });
    }

    render() {
        if (!this.hasCurrentState()) {
            return (<util.LoadingBar2 />);
        }

        let gps = this.state.gps;
        return (
            <div className="fade-in">
                <h1>Debug Info</h1>
                <pre>
                    {JSON.stringify(gps, null, 3)}
                </pre>
            </div>
        );
    }
}

export default util.withNavigation(GpsDebugView);